// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumBadge-cls1_gvx","cls2":"PremiumBadge-cls2_rcF PremiumBadge-cls1_gvx"};